import moment from 'moment';

import { IPosition, IStage } from '@entities/gantt/model/types';

export const isNeedChangeGanttDate = (stages: IStage[]): boolean => {
    const isPlannedStages = stages.some((stage) => stage.planned.startDate);
    if (!isPlannedStages) {
        return false;
    }

    const allPositions: IPosition[] = [];

    stages.forEach((stage) => {
        stage.positions.forEach((position) => {
            const { isParent } = position;
            if (isParent) {
                position.children.forEach((children) => {
                    allPositions.push(children);
                });
            } else {
                allPositions.push(position);
            }
        });
    });

    const sortedPositions = allPositions
        .filter((position) => position.planned.startDate && position.type === 'labor')
        .sort(
            (positionA, positionB) =>
                moment(positionA.planned.startDate).valueOf() -
                moment(positionB.planned.startDate).valueOf()
        );

    if (!sortedPositions.length) {
        return false;
    }
    const nowDate = moment().hour(0).minute(0).second(0);
    const estimateStartDate = sortedPositions[0].planned.startDate;
    const estimateStart = moment(estimateStartDate);

    return estimateStartDate && moment(nowDate).format() !== moment(estimateStartDate).format()
        ? estimateStart.isBefore(nowDate)
        : false;
};
